/* @flow */
/* eslint-disable babel/no-invalid-this */
import MediaType from "nexia_mobile/framework/media_type";
import Schema from "nexia_mobile/models/schema";
import type { ButtonPadFeature } from "./types";

export default function ButtonPad(feature: ButtonPadFeature) {
  let assignAction = feature.actions.assign;

  if (this._buttonSchema == null) {
    this._buttonSchema = new Schema(assignAction.data, { parse: true });
  }
  if (assignAction && assignAction.type === MediaType.SCHEMA) {
    this._buttonSchema.setUrl(assignAction.href);
  }

  this.getButtonSchema = () => {
    return this._buttonSchema;
  };
}



// WEBPACK FOOTER //
// ./src/models/mixins/device_features/button_pad.js